import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Exports / ProjTool", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { class: "mb-4 flex justify-between flex-col sm:flex-row" }
const _hoisted_5 = { class: "relative mb-2 sm:mb-0" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "inline-flex items-center px-3 border border-r-0 rounded-l-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex justify-between items-stretch" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Lock", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Export", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_LockClosedIcon = _resolveComponent("LockClosedIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_TruckIcon = _resolveComponent("TruckIcon")!
  const _component_export_proj_tool_table = _resolveComponent("export-proj-tool-table")!
  const _component_system_lock_modal = _resolveComponent("system-lock-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_date_picker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
          masks: {input: 'D. M. YYYY'},
          popover: { visibility: 'focus' },
          "is-range": ""
        }, {
          default: _withCtx(({ inputValue, inputEvents, isDragging }) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_CalendarIcon, { class: "h-5 w-5" })
                ]),
                _createElementVNode("input", _mergeProps({
                  readonly: "",
                  class: ["flex-grow px-3 py-2 w-full sm:w-52 rounded-md rounded-l-none border border-gray-200 text-sm text-gray-700", isDragging ? 'text-gray-500' : 'text-gray-700'],
                  value: _ctx.date.start && _ctx.date.end ? (inputValue.start + ' - ' + inputValue.end) : 'Select range'
                }, _toHandlers(inputEvents.start)), null, 16, _hoisted_8)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "masks"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_app_button, {
            onClick: _ctx.lockState,
            type: "blue",
            class: "mr-1 flex-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LockClosedIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_app_button, {
            onClick: _ctx.exportCsv,
            type: "blue",
            class: "ml-1 flex-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TruckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      (_openBlock(), _createBlock(_component_export_proj_tool_table, {
        dateFrom: _ctx.formatDate(_ctx.date.start),
        dateTo: _ctx.formatDate(_ctx.date.end),
        key: _ctx.date.start + _ctx.date.end
      }, null, 8, ["dateFrom", "dateTo"])),
      _createVNode(_component_system_lock_modal, {
        ref: "systemLockModal",
        systemLockReason: _ctx.SystemLockReason.ProjtoolReported,
        dateFrom: _ctx.formatDate(this.date.start),
        dateTo: _ctx.formatDate(this.date.end)
      }, null, 8, ["systemLockReason", "dateFrom", "dateTo"])
    ])
  ]))
}